import React from "react";
import { Link } from "@quintype/components";
import "./recipe.m.css";

export default function Ingredients({ ingredients }) {
  const items = ingredients.length > 0 && ingredients.split("\n");
  return (
    items.length > 0 && (
      <div styleName="ingredient-wrapper">
        <p styleName="header">Ingredients</p>
        <div styleName="styled-content">
          {items.map((item, index) => (
            <p key={`${item}-${index}`} dangerouslySetInnerHTML={{ __html: item }} />
          ))}
        </div>
        <div styleName="styled-links">
          <Link href={"mailto:?subject=Ingredients&body=" + encodeURIComponent(ingredients)} target="_blank">
            <span>Email this grocery list</span>
          </Link>
        </div>
        <div styleName="styled-links">
          <Link href="https://gulfnews.com/cooking-substitution" target="_self">
            Ingredient Substitution Guide
          </Link>
        </div>
      </div>
    )
  );
}
